export const itemsAPI = [
  {
    value: 'all',
    label: 'All APIs',
  },
  {
    value: 'enrichment',
    label: 'Enrichment API',
  },
  {
    value: 'discovery',
    label: 'Discovery API',
  },
  {
    value: 'prospector',
    label: 'Prospector API',
  },
  {
    value: 'watchlist',
    label: 'Watchlist API',
  },
];

export const itemsLog = [
  {
    value: 'all',
    label: 'All logs',
  },
  {
    value: 'request',
    label: 'Request logs',
  },
  {
    value: 'webhook',
    label: 'Webhook logs',
  },
];

export const itemsResponse = [
  {
    value: 'all',
    label: 'All responses',
  },
  {
    value: 'success',
    label: 'Successful responses',
  },
  {
    value: 'failure',
    label: 'Failed responses',
  },
  {
    value: '200',
    label: '200',
  },
  {
    value: '201',
    label: '201',
  },
  {
    value: '202',
    label: '202',
  },
  {
    value: '204',
    label: '204',
  },
  {
    value: '400',
    label: '400',
  },
  {
    value: '404',
    label: '404',
  },
  {
    value: '402',
    label: '402',
  },
  {
    value: '422',
    label: '422',
  },
  {
    value: '500',
    label: '500',
  },
];

export const successCodes = [200, 201, 202, 204];
export const failureCodes = [400, 404, 402, 422, 500];
